export const className = (...sections: string[]): string => {
  return `PersonalizationQueryBuilder__${sections.join('__')}`;
}